export enum SurveyType {
  All = 0,
  Survey = 1,
  Poll = 2,
  Feedback = 3,
  Trivia = 4,
  Predictor = 5,
  ScorePredictor = 6,
}

export enum AnswerType {
  Single = 0,
  Multiple = 1,
  Image = 2,
  Text = 3,
  ImageAndText = 4,
  Score = 5,
  Counter = 6,
  Dropdown = 7,
}

export enum AnswerDisplayType {
  ImageAndText = 0,
  Image = 1,
  Text = 2,
}

export enum PredictorAnswerType {
  None = 0,
  Home = 1,
  Away = 2,
}
